import { Col, Row } from 'react-styled-flexboxgrid';
import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

import { fontStyle } from '../../../theme/helpers/fontStyle';

export const $NeedHelpModalContent = styled.div`
  text-align: left;
`;

export const $Row = styled(Row)`
  padding: ${spacing('lg')} 0 ${spacing('lg')} 0;
`;

export const $PhoneIconCoCol = styled(Col)`
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

export const $CustomerSupportPhoneNumber = styled.div`
  ${fontStyle('lg')};
`;
